import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CentralCatalogueService } from '../../../services/central-catalogue/central-catalogue.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// add or edit a room / hall, including its booking flags. self-saving.
@Component({
  selector: 'app-cc-room-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './cc-room-dialog.component.html',
  styleUrls: ['../cc-dialog-form.scss', '../../../../common-style/ac-dialog.scss'],
})
export class CcRoomDialogComponent {
  form: FormGroup;
  isLoading: boolean = false;
  isEdit: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CcRoomDialogComponent>,
    private catalogueService: CentralCatalogueService,
    private toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: { room?: any; sets: any[] }
  ) {
    const row = this.data?.room;
    this.isEdit = !!row;
    this.form = this.fb.group({
      setId: [row?.setId || '', Validators.required],
      accommodationNumber: [row?.accommodationNumber ?? '', Validators.required],
      abbrevName: [row?.abbrevName || '', Validators.required],
      category: [row?.category || 'ROOM', Validators.required],
      bedCount: [row?.bedCount ?? '', Validators.required],
      floorNumber: [row?.floorNumber ?? '', Validators.required],
      totalCapacity: [row?.totalCapacity ?? '', Validators.required],
      status: [row?.status || 'ACTIVE', Validators.required],
      regularFlag: [row?.regularFlag === true],
      regularAutoAllocFlag: [row?.regularAutoAllocFlag === true],
      utsavFlag: [row?.utsavFlag === true],
      utsavAutoAllocFlag: [row?.utsavAutoAllocFlag === true],
      allocationType: [row?.allocationType || 'NONE'],
      allocationGender: [row?.allocationGender || 'NONE'],
      karmiReserved: [row?.karmiReserved || 'NO'],
      comments: [row?.comments || ''],
    });
  }

  get title(): string {
    return this.isEdit ? 'Edit room' : 'Add room';
  }

  submit(): void {
    if (this.form.invalid) {
      this.toastService.error(
        'Guest house, room number, short name, category, beds, floor and capacity are required.'
      );
      return;
    }
    this.isLoading = true;
    // status changes go through the Activate/Deactivate flow (which records a
    // reason); an edit keeps the stored status untouched.
    const payload = this.isEdit
      ? { ...this.form.value, status: this.data.room.status }
      : this.form.value;
    const request = this.isEdit
      ? this.catalogueService.updateAccommodation(this.data.room.accommodationId, payload)
      : this.catalogueService.addAccommodation(payload);

    request.subscribe({
      next: (res: any) => {
        const note = res?.data?.note ? ` ${res.data.note}` : '';
        this.toastService.success(`${res?.message || 'Saved.'}${note}`);
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to save the room.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
